var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c(
        "search-item",
        {
          key: _vm.identify,
          ref: _vm.identify,
          attrs: {
            "show-more-scheme": true,
            "col-settings": { span: 12 },
            "show-simple": _vm.showSimple,
            "expand-adv": true,
            "search-item-code": _vm.searchItemCode,
            "config-module": _vm.configModule,
            "auto-init": _vm.searchItemAutoInit,
            "custom-search-items": _vm.customSearchItems,
            "custom-sim-query-placeholder": _vm.simQueryPlaceholder
          },
          on: {
            advSearchItemCallBack: _vm.fetchData,
            simSearchItemCallBack: _vm.fetchDataByKeyWord,
            advToggle: _vm.scrollCallback
          }
        },
        [
          _c("template", { slot: "operations" }, [_vm._t("operations")], 2),
          _c(
            "template",
            { slot: "searchAreaHeader" },
            [_vm._t("searchAreaHeader")],
            2
          )
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "section grid-wrapper",
          staticStyle: { "min-height": "300px" }
        },
        [
          _c("cargo-ag-grid", {
            attrs: {
              "config-module": _vm.gridConfigModule,
              "grid-params": _vm.chargeGrid.gridParams,
              "grid-options": _vm.chargeGrid.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.chargeGrid.rowData
            },
            on: {
              "update:gridParams": function($event) {
                return _vm.$set(_vm.chargeGrid, "gridParams", $event)
              },
              "update:grid-params": function($event) {
                return _vm.$set(_vm.chargeGrid, "gridParams", $event)
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-wrapper", attrs: { id: "footer-wrapper" } },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "flex-end",
                "flex-wrap": "wrap"
              }
            },
            [
              _vm.reCalc
                ? _c("charge-currency-total-group", {
                    attrs: {
                      "amount-to-currency": _vm.localCurrency,
                      "data-field": "chargeAmount",
                      "currency-field": "chargeCurrency",
                      "rate-field": "chargeRate",
                      "ar-field": "chargeReceivable",
                      "arap-group": false,
                      "arap-order": "ap",
                      type: "auto",
                      "data-provider":
                        _vm.totalAmountToCurrencyChargeGrid.dataProvider
                    }
                  })
                : _vm._e(),
              _vm.reCalc && _vm.showChargeCount
                ? _c("charge-count-group", {
                    attrs: {
                      "new-by-job": _vm.newByJob,
                      "selected-count":
                        _vm.totalAmountToCurrencyChargeGrid.selectedCount,
                      "data-provider":
                        _vm.totalAmountToCurrencyChargeGrid
                          .chargeCountGroupDataProvider,
                      "display-and-count-field-list":
                        _vm.totalAmountToCurrencyChargeGrid
                          .displayAndCountFieldList,
                      "basic-currency": _vm.localCurrency,
                      "always-show": _vm.alwaysShow
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c("cargo-pagination", {
            attrs: {
              "config-module": _vm.gridConfigModule,
              total: _vm.searchConditions.totalChargeGrid,
              page: _vm.searchConditions.pageNumChargeGrid,
              limit: _vm.searchConditions.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(
                  _vm.searchConditions,
                  "pageNumChargeGrid",
                  $event
                )
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.searchConditions, "pageSize", $event)
              },
              pagination: _vm.fetchDataByPage
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }